export type s3PostConfig = {
    file: File
    signedUrl: {
        fields: Record<string, string>
        url: string
    }
}

export const NO_FILE_KEY_FOUND = "none"

export async function s3PostFile(
    config: s3PostConfig
): Promise<string> {
    const {file, signedUrl} = config
    try {
      const formData = new FormData()
      formData.append("Content-Type", file.type)
      formData.append("success_action_status", "201")
      Object.entries(signedUrl.fields).forEach(([key, value]) => {
        formData.append(key, value)
      })
      formData.append("file", file)
  
      const result = await fetch(signedUrl.url, {
        method: "POST",
        body: formData,
      })
      const xmltext = await result.text()
      const parser = new DOMParser()
      const xmldoc = parser.parseFromString(xmltext, "text/xml")
      const key = xmldoc.querySelector("Key")
      return key?.textContent || NO_FILE_KEY_FOUND
    } catch (error) {
      throw error
    }
}